export default "__VITE_ASSET__9iwhdj1m__"